import React from 'react';
import PropTypes from 'prop-types';
import { useNotify } from 'react-admin';
import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';

const WorkFlowButton = ({ actData, record, ...rest }) => {
  const notify = useNotify();
  const navigate = useNavigate();

  const handleClick = () => {
    const updatedRecord = { ...record, [actData.StateColumn]: actData.StateValue };

    // Uncomment and update the following code when ready to use your dataProvider.
    /*
    dataProvider(UPDATE, `${actData.Module}`, { id: record.id, data: updatedRecord })
      .then(() => {
        notify(`${actData.alert_accept}`, { type: 'success' });
        navigate(`/${actData.Module}`);
      })
      .catch((e) => {
        console.error(e);
        notify(`${actData.alert_error}`, { type: 'warning' });
      });
    */
  };

  return (
    <Button onClick={handleClick} {...rest}>
      {actData.title}
    </Button>
  );
};

WorkFlowButton.propTypes = {
  actData: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
};

export default WorkFlowButton;
